import PortalShell from "../../components/PortalShell";
import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function QuestionBank() {
  const [topics, setTopics] = useState([]);
  const [filters, setFilters] = useState({ board: "", tier: "", year: "", topic: "" });
  const [qs, setQs] = useState([]);
  const [revealed, setRevealed] = useState({});

  useEffect(() => { api.get("/questions/topics").then(r => setTopics(r.data.topics || [])); }, []);

  useEffect(() => {
    const params = {};
    Object.entries(filters).forEach(([k,v]) => { if (v) params[k] = k === "year" ? Number(v) : v; });
    params.limit = 30;
    api.get("/questions", { params }).then(r => setQs(r.data)).catch(()=>{});
  }, [filters]);

  return (
    <PortalShell role="student" title="Question Bank" subtitle="19,000+ curated GCSE maths problems. Filter to find exactly what you need.">
      <div className="bg-white rounded-xl border border-slate-200 p-5 mb-6 grid md:grid-cols-4 gap-4">
        <Select label="Board" val={filters.board} set={v=>setFilters({...filters, board:v})} options={["","AQA","Edexcel","OCR"]} testid="filter-board"/>
        <Select label="Tier" val={filters.tier} set={v=>setFilters({...filters, tier:v})} options={["","Foundation","Higher"]} testid="filter-tier"/>
        <Select label="Year" val={filters.year} set={v=>setFilters({...filters, year:v})} options={["",7,8,9,10,11]} testid="filter-year"/>
        <Select label="Topic" val={filters.topic} set={v=>setFilters({...filters, topic:v})} options={["", ...topics]} testid="filter-topic"/>
      </div>

      <div className="space-y-4">
        {qs.length === 0 && <div className="text-center text-sm text-slate-500 p-12 border border-dashed rounded-xl bg-white">No questions for these filters.</div>}
        {qs.map((q, i) => (
          <div key={q.id} className="bg-white rounded-xl border border-slate-200 p-6" data-testid={`qb-item-${i}`}>
            <div className="flex flex-wrap gap-2 mb-3 text-[10px] uppercase tracking-widest">
              <span className="px-2 py-1 rounded bg-brand-gold text-brand-navy font-semibold">{q.board}</span>
              <span className="px-2 py-1 rounded border border-slate-300 text-slate-600">{q.tier}</span>
              <span className="px-2 py-1 rounded border border-slate-300 text-slate-600">Year {q.year}</span>
              <span className="px-2 py-1 rounded border border-slate-300 text-slate-600">{q.topic}</span>
              {q.subtopic && <span className="px-2 py-1 rounded border border-slate-300 text-slate-600">{q.subtopic}</span>}
            </div>
            <div className="font-serif text-lg brand-navy mb-4">{q.question}</div>
            {q.options?.length > 0 && (
              <div className="grid md:grid-cols-2 gap-2 mb-4">
                {q.options.map((o, idx) => (
                  <div key={idx} className="px-3 py-2 text-sm rounded border border-slate-200 bg-slate-50">
                    <span className="text-slate-400 mr-2">{String.fromCharCode(65+idx)}.</span>{o}
                  </div>
                ))}
              </div>
            )}
            <button onClick={() => setRevealed(r => ({...r, [q.id]: !r[q.id]}))} className="text-xs gold-text font-medium" data-testid={`reveal-${i}`}>
              {revealed[q.id] ? "Hide" : "Show"} answer & solution
            </button>
            {revealed[q.id] && (
              <div className="mt-3 p-4 rounded-md bg-slate-50 border border-slate-200 text-sm">
                <div className="mb-2"><strong className="brand-navy">Answer: </strong>{q.correct}</div>
                <div><strong className="brand-navy">Solution: </strong>{q.explanation}</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </PortalShell>
  );
}

function Select({label,val,set,options,testid}){return(<div><label className="text-[10px] uppercase tracking-widest text-slate-500 mb-1.5 block">{label}</label><select data-testid={testid} value={val} onChange={e=>set(e.target.value)} className="w-full border border-slate-300 rounded-md px-3 py-2.5 bg-white text-sm">{options.map((o,i)=><option key={i} value={o}>{o===""?"All":o}</option>)}</select></div>);}
